import { render, staticRenderFns } from "./wrench-right.vue?vue&type=template&id=534090c4"
import script from "./wrench-right.vue?vue&type=script&lang=js"
export * from "./wrench-right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports